<template>
  <div>
    <!--<a id="show-sidebar" class="btn btn-sm btn-dark" href="javascript:void(0)" onclick="showSidebar();">-->
    <a id="show-sidebar" class="btn btn-sm btn-dark" href="javascript:void(0)">
      <i class="fas fa-bars"></i>
    </a>
    <nav id="sidebar" class="sidebar-wrapper">
      <div class="sidebar-content">
        <div class="sidebar-brand">
          <a href="javascript:void(0)" @click="gohome()"><img src="static/images/logo_white.png" alt=""></a>
          <!--<div id="close-sidebar" onclick="closeSidebar();">-->
          <div id="close-sidebar">
            <i class="fas fa-times"></i>
          </div>
        </div>
        <div class="sidebar-menu">
          <ul>
            <!--<li class="sidebar-dropdown active" id="ck-test-menu" onclick="sidebarDropdown(this);">-->
            <li class="sidebar-dropdown active" id="ck-orderplanning-menu">
              <a href="javascript:void(0)">
                <i class="fa fa-cube"></i>
                <span>Mobile Apps</span>
              </a>
              <div class="sidebar-submenu" style="display: block;">
                <ul>
                  <li class="select-image" v-bind:class="{ active: $store.getters.selectedTab=='ckone' }" @click="$store.commit('selectedTab', 'ckone')">
                    <a href="javascript:void(0)">CKOne App</a>
                  </li>
                  <li class="select-image" v-bind:class="{ active: $store.getters.selectedTab=='xstore' }" @click="$store.commit('selectedTab', 'xstore')">
                    <a href="javascript:void(0)">XStore App</a>
                  </li>
                  <!-- <li class="select-image" v-bind:class="{ active: $store.getters.selectedTab=='ckonem' }" @click="$store.commit('selectedTab', 'ckonem')">
                    <a href="javascript:void(0)">Search Result</a>
                  </li> -->
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <!-- sidebar-menu  -->
      </div>
      <!-- sidebar-content  -->
      <div class="sidebar-footer">
        <a href="javascript:void(0)">
          {{userName}}
          <!--<span><?=$_SESSION['authuser']?></span>-->
        </a>
        <!--<a href="javascript:void(0)">
            <i class="fa fa-cog"></i>
        </a>-->
        <a href="javascript:void(0)" @click="confirmLogout()" data-toggle="tooltip" data-placement="top" title="Logout">
          <i class="fa fa-power-off"></i>
        </a>
      </div>
    </nav>
    <!-- sidebar-wrapper  -->
  </div>
</template>

<script>
  import { bus } from './../../../main.js'

  export default {
    name: 'MainSidebar',
    data() {
      return {
        userName: localStorage.getItem('username')
      }
    },
    methods: {
      confirmLogout(){
        let vm = this;
        Swal.fire({
          title: 'Are you sure you want to logout?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then( function(result){
          if (result.value) {
            vm.$auth.destroyToken();
            // vm.$router.push('/');
            location.reload();
          }
        });
      },
      gohome(){
        this.$router.push('/');
        location.reload();
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/mobileapps/layout/MainSidebar.vue